export default {
  'FAQ.subject': 'Subject',
  'FAQ.content': 'Content',
  'FAQ.keyWords': 'Key Words',
  'FAQ.newCategory': 'New Category',
  'FAQ.publish': 'Publish',
  'FAQ.more': 'More',
  'FAQ.nameValid': 'Only numbers and letters and _- []{}() can be entered',
  'FAQ.deleteSubjectTip': 'Are you sure delete this subject?',
  'FAQ.deleteCategoryTip': 'Are you sure delete this category?',
  'FAQ.addCategory': 'Category added successfully',
  'FAQ.delCategory': 'Category deleted successfully',
  'FAQ.addFAQ': 'FAQ added successfully',
  'FAQ.editFAQ': 'FAQ modified successfully',
  'FAQ.delFAQ': 'FAQ deleted successfully',
  'FAQ.publishFAQ': 'FAQ published successfully',
  'FAQ.queryTip': 'You can query the information by some key words',
  'FAQ.selectCategory': 'Please select category',
  'FAQ.keywordsTip': 'Keywords can be separated by commas',
};
